import React, {useCallback, useEffect, useRef} from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

// Components
import {Typography} from '@nur-portal/ui-kit';

// Styles
import styles from './comment-input.module.css';

const TEXTAREA_DEFAULT_HEIGHT = 48;
const {platform} = window.Site.targeting;
const isMobile = platform === 'smartphone';

const CommentInput = ({onInput, value, onFocus, onBlur}) => {
  const counterSeparator = '/';
  const maxCounterValue = 2700;
  const ref = useRef();

  const handleTextArea = event => {
    let text = event.target.value;

    if (text.trim().length === 0) {
      text = text.trim();
      ref.current.style.height = `${TEXTAREA_DEFAULT_HEIGHT}px`;
    } else {
      ref.current.style.height = `${ref.current.scrollHeight}px`;
    }

    if (text.length <= maxCounterValue) {
      onInput(text);
    }
  };

  const onFocusInput = useCallback(() => {
    if (isMobile) {
      onFocus(() => ref.current.scrollIntoView({inline: 'center', block: 'center'}));
    }
  }, [ref]);

  const getStringLength = str => str.length;

  useEffect(() => {
    ref.current.focus();
  }, []);

  return (
    <div className={styles.inputWrapper}>
      <textarea
        cols={3}
        className={styles.textArea}
        value={value}
        onChange={handleTextArea}
        name="commentText"
        placeholder="Напишите комментарий..."
        ref={ref}
        onFocus={onFocusInput}
        onBlur={onBlur}
      />
      <div className={styles.counter}>
        <Typography
          className={styles.counterText}
          component='span'
        >
          {getStringLength(value)}
          {counterSeparator}
        </Typography>
        <Typography
          component='span'
          className={clsx(styles.counterText, styles.greyText)}
        >
          {maxCounterValue}
        </Typography>
      </div>
    </div>
  );
};

CommentInput.propTypes = {
  onInput: PropTypes.func.isRequired,
  value: PropTypes.string,
  onFocus: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired
};

CommentInput.defaultProps = {
  value: ''
};

export default CommentInput;
